import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './returns.details.actions';

const initialState = {
  returnIdToModalIdMap: {},
};

const deleteModalState = (newState, returnDetailModalId) => {
  const newStateWithoutModalState = { ...newState };
  if (newState.returnIdToModalIdMap) {
    newStateWithoutModalState.returnIdToModalIdMap = Object.keys(newState.returnIdToModalIdMap).reduce((map, key) => {
      if (key === returnDetailModalId) {
        return map;
      }

      return map[key] === newState.returnIdToModalIdMap[key];
    }, {});
  }

  delete newStateWithoutModalState[returnDetailModalId];
  return newStateWithoutModalState;
};

const actionHandlerMap = {
  [Actions.RETURN_DETAILS_MODAL_OPEN]: (state, { returnId, returnDetailModalId, modalId }) => {
    return {
      ...state,
      returnIdToModalIdMap: {
        ...state.returnIdToModalIdMap,
        [returnId]: returnDetailModalId,
      },
      [returnDetailModalId]: {
        isLoading: true,
        returnShipment: {
          fulfillmentId: returnId,
        },
        modalId,
      },
    };
  },
  [Actions.RETURN_DETAILS_MODAL_CLOSED]: (state, { returnDetailModalId }) => deleteModalState({ ...state }, returnDetailModalId),
  [Actions.GET_RETURN_DETAILS_SUCCESS]: (state, { returnDetailModalId, returnShipment }) => ({
    ...state,
    [returnDetailModalId]: {
      ...state[returnDetailModalId],
      isLoading: false,
      returnShipment,
    },
  }),
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './returns.details.reducer.metadata';
